/** The "Help" button on a module's screen: opens that module's step-by-step topic. */
import { useState } from 'react';
import { CircleHelp } from 'lucide-react';
import { HELP } from '../lib/help';
import { Button, Modal } from './ui';

export function HelpButton({ topic }: { topic: keyof typeof HELP }): JSX.Element {
  const [open, setOpen] = useState(false);
  const help = HELP[topic];
  return (
    <>
      <Button variant="ghost" onClick={() => setOpen(true)} aria-label={`Help: ${help.title}`}>
        <CircleHelp aria-hidden="true" className="h-4 w-4" /> Help
      </Button>
      {open && (
        <Modal title={`Help: ${help.title}`} description={help.intro} onClose={() => setOpen(false)}>
          <div className="space-y-4 text-sm text-slate-700 dark:text-slate-200">
            {help.sections.map((section) => (
              <section key={section.heading}>
                <h3 className="mb-1 font-semibold text-navy dark:text-white">{section.heading}</h3>
                <ol className="list-decimal space-y-1 pl-5">
                  {section.steps.map((step) => (
                    <li key={step}>{step}</li>
                  ))}
                </ol>
              </section>
            ))}
          </div>
          <div className="mt-5 flex justify-end">
            <Button variant="secondary" onClick={() => setOpen(false)}>
              Close
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
}
